<template>
  <div class="form_wrap">
    <p>*以下信息已加密保护，仅用于运营商实名认证*</p>
    <!-- form表单开始-->
    <div>
      <van-form :validate-first="true" @submit="onSubmit" id="resetForm">
        <!-- 手机号 -->
        <van-field label="用户姓名：" required v-model="userName" placeholder="请输入办理人姓名（已加密）" :rules="userRules"
          name="userName"></van-field>
        <!-- 手机号 -->
        <van-field label="联系电话：" @input="showContent" required v-model="mobile" placeholder="请输入联系电话（已加密）"
          :rules="telRules" name="mobile"></van-field>
        <div style="display: none" class="content">
          <!-- 身份证号 -->
          <van-field label="身份证号：" required v-model="cardNum" placeholder="请输入身份证号码（已加密）" :rules="cardRules"
            name="cardNum"></van-field>
          <!-- 收货地区 -->
          <van-field required is-link readonly clickable name="areaValue" :value="areaValue" label="地区选择"
            placeholder="请选择所在地区" @click="showArea = true" />
          <van-popup v-model="showArea" position="bottom">
            <van-cascader :options="options" @finish="onFinish" title="请选择所在地区" @close="showArea = false" />
          </van-popup>
          <!-- 详细地址 -->
          <van-field label="详细地址：" required v-model="address" placeholder="街道/镇+村/小区/写字楼+门牌号" name="address">
          </van-field>
        </div>
        <div class="checked_wrap">
          <div>
            <van-field name="checkbox" class="checked">
              <template #input>
                <van-checkbox v-model="checkbox" shape="square" />
              </template>
            </van-field>
          </div>
          <div style="color: #c6c6c6">
            提交即视为您已同意
            <span @click="showNet" style="color: #2a9ee4">《入网协议》</span>
            <span @click="showInfo" style="color: #2a9ee4">《信息收集公告》</span>
          </div>
        </div>
        <!-- 入网协议弹框 -->
        <van-dialog v-model="showData1" title="入网协议" :show-cancel-button="false" confirmButtonColor="#2A9EE4">
          <ruwang-view></ruwang-view>
        </van-dialog>
        <!-- 信息收集公告弹框 -->
        <van-dialog v-model="showData2" title="个人信息收集证明" confirmButtonColor="#2A9EE4">
          <info-view></info-view>
        </van-dialog>
        <p>*请填写真实身份信息/联系电话/收货地址错误无法发货*</p>
        <!-- 提交按钮 -->
        <!-- <van-sticky style="margin: 0.32rem;">
              <van-button round block type="info"  @click="scroll" native-type="submit" class="ballon " ref="btn">现在领取，包邮到家</van-button>
            </van-sticky> -->
      </van-form>
    </div>
    <!-- form表单结束 -->
  </div>
</template>
<script>
import RuwangView from "@/components/compent/RuwangView.vue";
import InfoView from "@/components/compent/InfoView.vue";
import { Toast } from "vant";
import { Dialog } from "vant";
import utils from "@/assets/js/utils.js";
import solutionUtil from "@/assets/js/solutionUtil";
import { provs_data, citys_data, dists_data } from "@/assets/js/LAreaData3.js";
export default {
  components: { RuwangView, InfoView },
  props: ["checkColor", "pageName"],
  data() {
    return {
      userName: "",
      cardNum: "",
      areaValue: "",
      areaCode: [],
      options: [],
      showArea: false,
      address: "",
      mobile: "",

      isTrue: true,
      checkbox: false,
      showData1: false,
      showData2: false,
      userRules: [
        {
          validator: (value) => {
            // 用户名验证
            return /^[\u4e00-\u9fa5]{2,4}$/.test(value);
          },
          message: "请输入正确的用户名！",
          trigger: "onBlur",
        },
      ],
      telRules: [
        {
          // 手机号验证
          validator: (value) => {
            return /^[1][3,4,5,7,8,9][0-9]{9}$/.test(value);
          },
          message: "请输入正确的手机号！",
          trigger: "onBlur",
        },
      ],
      cardRules: [
        {
          validator: (value) => {
            // 身份证号验证
            return /(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(value);
          },
          message: "请输入正确的身份证号！",
          trigger: "onBlur",
        },
      ],
    };
  },
  methods: {
    // 提交表单信息
    onSubmit(value) {
      let closeTost = Toast.loading({
        message: "领取中...",
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
      });
      if (this.isTrue) {
        let params = {
          consigneeName: this.userName,
          consigneePhone: this.mobile,
          ownersName: this.userName,
          detailAddress: this.address,
          idCardNo: this.cardNum,
          planId: utils.getQueryVariable("planId"),
          // 省市区
          countyCode: this.areaCode[2],
          formVaildType: this.pageName,

          click_id: utils.getQueryVariable("click_id"),
          qz_gdt: utils.getQueryVariable("qz_gdt"),
          time_stamp: utils.getQueryVariable("time_stamp"),
          // B站参数
          track_id: utils.getQueryVariable("track_id"),
          // 腾讯参数
          convertId: utils.getQueryVariable("convertId"),
          buyerCode: utils.getQueryVariable("buyerId"),
          // 广告参数
          adid: utils.getQueryVariable('adid'),
          creativeid: utils.getQueryVariable('creativeid'),
          creativetype: utils.getQueryVariable('creativetype'),
          clickid: utils.getQueryVariable('clickid')
        };
        if (
          this.areaValue &&
          this.address.length >= 4 &&
          this.address.length < 150
        ) {
          this.checkbox = true;
          this.isTrue = false;
          //发起Post请求
          this.$axios
            .post("/data/h5/submit", params, {
              Headers: { "Content-Type": "application/json" },
            })
            .then((res) => {
              this.isTrue = true;
              closeTost.clear();
              let { code, msg } = res.data;
              if (code === "200") {
                let convertId = utils.getQueryVariable("convertId");
                if (convertId) {
                  this.callback();
                }
                //弹出领取成功框和清空表单信息
                this.$emit("showData", true);
                document.querySelector("#resetForm").reset();
              } else if (code === "1000") {
                Dialog.alert({
                  title: `${msg}`,
                  message: "请检查身份信息是否正确！",
                }).then(() => {
                  Dialog.close();
                });
              } else {
                Dialog.alert({
                  title: `${msg}`,
                  message: solutionUtil.getSolution(code),
                }).then(() => {
                  Dialog.close();
                });
              }
            })
            .catch((err) => {
              closeTost.clear();
              Dialog.alert({
                title: `领取失败`,
                message: "请检查身份信息是否正确！",
              }).then(() => {
                Dialog.close();
              });
              this.isTrue = true;
            });
        } else if (this.areaCode.length == 0) {
          Toast("请选择正确收货地区！");
        } else if (this.address.length < 4 || this.address.length > 150) {
          Toast("请输入正确的地址信息！");
        }
      }
    },
    // 处理地区内容
    onFinish({ selectedOptions }) {
      this.areaCode = selectedOptions.map((item) => {
        return item.value;
      });
      this.fieldValue = selectedOptions
        .map((option) => {
          return option.text;
        })
        .join("-");
      this.areaValue = this.fieldValue;
      this.showArea = false;
    },
    // 显示入网协议弹框
    showNet() {
      this.showData1 = true;
    },
    //显示信息收集公告弹框
    showInfo() {
      this.showData2 = true;
    },
    // 地区数据处理
    getData() {
      for (var i = 0; i < provs_data.length; i++) {
        for (const key1 in citys_data) {
          if (provs_data[i].value == key1) {
            provs_data[i].children = citys_data[key1];
          }
          for (let j = 0; j < citys_data[key1].length; j++) {
            for (const key2 in dists_data) {
              if (citys_data[key1][j].value == key2) {
                citys_data[key1][j].children = dists_data[key2];
              }
            }
          }
        }
      }
      this.options = provs_data;
    },
    // 快手的回调
    callback(val) {
      _ks_trace.push({
        event: "form",
        convertId: val,
        cb: function () {
          console.log("Your callback function here!");
        },
      });
    },
    //判断电话内容并显示下面表单
    showContent() {
      this.content = document.querySelector(".content");
      if (this.mobile.length >= 1) {
        this.content.style.display = "block";
      }
    },
    // 点击提交按钮让表单滚动到页面中心
    scroll() {
      window.scrollTo(0, "375");
    },
  },
  mounted() {
    // 初始化地区数据
    this.getData();
    let checked = document.querySelector(".checked");
    checked.style.backgroundColor = this.checkColor;
  },
};
</script>

<style lang="scss" scoped>
.form_wrap {
  text-align: center;
  padding: 0.1rem 0.4rem;
  font-family: -apple-system-font, Helvetica Neue, sans-serif;

  .van-field {
    margin: 0.2rem 0;
    border-radius: 0.2rem;
  }

  .checked_wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.2rem;

    .checked {
      padding: 0;
      margin: 0;
      border-radius: 0;
      margin-right: 0.1rem;

      .van-checkbox {
        background-color: #fff;
        border-radius: 25%;
      }
    }

    img {
      display: block;
      width: 2rem;
      height: 4rem;
    }
  }

  p {
    color: #f00;
    font-size: 0.2rem;
    margin-top: 0.1rem;
    font-style: oblique;
  }

  ::v-deep.van-dialog__header {
    font-weight: 600;
    font-size: 95%;
  }

  ::v-deep.van-dialog__content {
    font-size: 80%;
    letter-spacing: 0.03rem;
    margin: 0.3rem 0 0.4rem 0;
  }

  .ballon {
    color: #f1f2f4;
    width: 100%;
    font-size: 0.6rem;
    padding: 0.16rem 0.04rem;
    letter-spacing: 0.04rem;
    cursor: pointer;
    border: none;
    outline: none;
    font-weight: 600;
    background: -webkit-linear-gradient(#e53a2a, #f9a766);
    text-transform: uppercase;
    border-radius: 0.3rem;
    animation: scaleDraw 5s ease-in-out infinite;
    -webkit-animation: scaleDraw 3s ease-in-out infinite;
  }

  ::v-deep.van-sticky--fixed {
    position: fixed;
    top: auto;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 99;
    padding: 0.2rem 0.7rem;
  }

  ::v-deep.van-field--error .van-field__control {
    color: #323232;
  }
}

@keyframes scaleDraw {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(1.2);
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.2);
  }
}
</style>
